import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'
import plugins from './plugins'
import { ICartState } from './modules/cart'
import { IDataState } from './modules/data'
import { IMatrixState } from './modules/matrix'

export interface IRootState {
  cartOpen: boolean
  cart?: ICartState
  data?: IDataState
  debug: boolean
  matrix?: IMatrixState
  oCode?: boolean | string
  offlineMode: boolean
  profile: object
  sidebarOpen: boolean
  theme: string
}

Vue.use(Vuex)

const defaultState = {
  cartOpen: false,
  debug: false,
  oCode: false,
  offlineMode: false,
  profile: {},
  sidebarOpen: false,
  theme: 'theme/default/'
}

if (window.localStorage) {
  const parsedUrl = new URL(window.location.href)
  const localState = JSON.parse(window.localStorage.getItem('rodenstock') || '{}')
  const oCode = parsedUrl.searchParams.get('ocode') || false
  const debugParam = parsedUrl.searchParams.get('debug')
  const offlineParam = parsedUrl.searchParams.get('offline')
  if (oCode) {
    localState.oCode = oCode
  }
  localState.debug = (Boolean(debugParam) && (debugParam !== '0'))
  localState.offlineMode = (Boolean(offlineParam) && (offlineParam !== '0'))
  Object.assign(defaultState, localState)
}

const getters = {
  debug: (s: IRootState) => s.debug,
  oCode: (s: IRootState) => s.oCode,
  offlineMode: (s: IRootState) => s.offlineMode,
  profile: (s: IRootState) => s.profile,
  theme: (s: IRootState) => s.theme
}

const mutations = {
  SET_DEBUG_MODE (s: IRootState, debug: boolean) {
    s.debug = (debug)
  },
  SET_OFFLINE_MODE (s: IRootState, offline: boolean) {
    s.offlineMode = (offline)
  },
  SET_OPTICIAN_CODE (s: IRootState, code: string) {
    s.oCode = code
  },
  SET_THEME (s: IRootState, theme: string) {
    s.theme = theme
  }
}

const actions = {
  async setDebugMode ({ commit }: ActionContext<IRootState, IRootState>, debug: string) {
    commit('SET_DEBUG_MODE', (Boolean(debug) && (debug !== '0')))
  },
  async setOfflineMode ({ commit }: ActionContext<IRootState, IRootState>, offline: string) {
    commit('SET_OFFLINE_MODE', (Boolean(offline) && (offline !== '0')))
  },
  async setOpticianCode ({ commit }: ActionContext<IRootState, IRootState>, code: string) {
    commit('SET_OPTICIAN_CODE', code)
  },
  async setTheme ({ commit }: ActionContext<IRootState, IRootState>, theme: string) {
    commit('SET_THEME', theme)
  }
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({
  state: () => (defaultState),
  mutations,
  getters,
  actions,
  plugins
})
